import React from "react"
import { StyledH2 } from "./styles/StyledHeadings"

function Heading({ title }) {
  return <StyledH2>{title}</StyledH2>
}

export default Heading
